import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right-bg",
  "use": "icon-right-bg-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"none\" id=\"icon-right-bg\">\r\n                  <circle cx=\"10\" cy=\"10\" r=\"10\" fill=\"#006FFF\" />\r\n                  <path d=\"M6 9.65723L8.47487 12.1321C8.67014 12.3274 8.98672 12.3274 9.18198 12.1321L14.4853 6.8288\" stroke=\"white\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\r\n                </symbol>"
});
var result = sprite.add(symbol);
export default symbol